import { NotFound } from '@/components/pages/Errors/NotFound'
import { Page } from '@/core/architecture'

import { UserItemDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * UserItemDetail Page
 * Implemented as a practical sample.
 */
export const UserItemDetail: Page = () => {
  const { state, actions } = useViewModel()

  if (!state.loading && !state.item) {
    return <NotFound useNextRouter={false} />
  }

  return <UserItemDetailTemplate state={state} {...actions} />
}
